import axios from 'axios';
import { config } from '../apiConfig';

const RequestOrganizationCodeWithAuth = async (parameters) => {
    let response = await axios.post(`${config.url}/api/mvc/OrganizationMember/RequestOrganizationCodeWithAuth`, parameters).catch((err) => {
        return err.response;
    });
    return response;
}

export default RequestOrganizationCodeWithAuth;